import React, {useEffect, useState} from "react";
import "./MateDebug.css";
import Row from "react-bootstrap/Row";
import MateClient from "../MateClient";
import Col from "react-bootstrap/Col";
import MateApi from "../../../lib/api/mate";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAnchor, faExpand, faX} from "@fortawesome/free-solid-svg-icons";
import {faBluetoothB} from "@fortawesome/free-brands-svg-icons";
import {sleep} from "../../../lib/utils";


window.loadPairedMates = false;

if (navigator.bluetooth === undefined) {
    alert("Web Bluetooth API is not supported in this browser. Please use a compatible browser like Chrome or Edge.");
}

function MateDebug({bond}) {

    const [mateSearchApi, setMateSearchApi] = useState(new MateApi("mate_search"));
    const [mateClients, setMateClients] = useState([]);
    const [pairedMateClients, setPairedMateClients] = useState([]);
    const [mateClientsSizes, setMateClientsSizes] = useState({});


    useEffect(() => {
        if (window.loadPairedMates) return
        window.loadPairedMates = true
        checkPairedDevices().then(mates => {
            console.log("Paired mates found:", mates);
            setPairedMateClients(mates);
        });
    }, [pairedMateClients]);


    const checkPairedDevices = async () => {
        let devices = await mateSearchApi.searchPairedDevices();
        return devices.map(d => d.mate)
    }

    const removeMateClient = (m) => {
        const _mateId = m.id;
        const mateToRemove = mateClients.find(mate => mate.id === _mateId);

        if (mateToRemove) {
            mateToRemove.removePairedDevice().then(() => {
                mateToRemove.disconnect().then();
            });
        }
        setPairedMateClients(pairedMateClients.filter(mate => mate.id !== _mateId))
        setMateClients(mateClients.filter(mate => mate.id !== _mateId));
    }


    const addMateClient = async () => {
        if (!mateSearchApi.isSupported()) {
            console.error('❌ Web Bluetooth API is not supported in this browser');
            return;
        }

        try {
            console.log('🔍 Starting Bond Blue device scan...');
            const _mate = await mateSearchApi.requestBondBlueDevice();
            if (_mate) {
                let _added = false;
                for (let m of pairedMateClients) {
                    if (m.device && m.device.id === _mate.device.id) {
                        _added = true
                    }
                }
                if (!_added) setMateClients([...mateClients, _mate]);
            }
        } catch (error) {
            console.error('❌ Error during Bond Blue scan:', error);
        }
    };


    const getColSize = (mate) => {
        if (mateClientsSizes[mate.id]) return 12;
        if (mateClients.length === 1) return 6;
        if (mateClients.length === 2) return 6;
        if (mateClients.length === 3) return 4;
        if (mateClients.length >= 4) return 3;
        return 6;
    }


    return <Row>
        <Row className={"p-3"}>
            <h3>Mate Debug
                <Button onClick={addMateClient} className={"ms-2 me-2"} variant={"outline-primary"}>
                    <FontAwesomeIcon icon={faBluetoothB}/> Scan
                </Button>
            </h3>
        </Row>
        {[...mateClients, ...(pairedMateClients || [])].map((mate, index) => (<Col
            key={mate.bondid + "+" + index}
            xs={12}
            sm={12}
            md={getColSize(mate)}
            lg={getColSize(mate)}
            xl={getColSize(mate)}
            className={"mateCol mb-3"}
        >
            {mate.device && <Button variant={"outline-danger"} className={"closeMateBtn"}
                                    onClick={() => removeMateClient(mate)}>
                <FontAwesomeIcon icon={faX} className={""}/></Button>}

            <Button variant={"outline-primary"} className={"expandMateBtn me-2"} onClick={() => {
                mateClientsSizes[mate.id] = !mateClientsSizes[mate.id];
                setMateClientsSizes({...mateClientsSizes})
            }}>
                <FontAwesomeIcon icon={faExpand} className={"me-2"}/>
            </Button>
            <MateClient bond={bond} mate={mate}/>
        </Col>))}

    </Row>;


}

export default MateDebug;
